import { graphql } from '~/gql'

export const GET_FACILITY_APP_BAR_DATA_QUERY = graphql(`
  query GetFacilityAppBarData($id: ID!, $floorId: ID, $versionId: ID) {
    facility: Facility(id: $id) {
      id
      name
      isTemplate
      author {
        id
        name
      }
      floor(floorId: $floorId) {
        id
        name
        versions {
          id
          name
        }
        version(versionId: $versionId) {
          id
          name
        }
      }
      floors {
        id
        name
        version {
          id
        }
      }
    }
  }
`)
